import { PERMISSION_CHECK } from '@/utils/constants';
import { isEmptyObjectCheck } from '@/utils/utils';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import PartnerRegistryGrid from '../partner-registry-grid/partner-registry-grid';
import { EventBus } from '@/main';

@Component({
    name: 'partner-registry-page',
    components: {
        'partner-registry-grid': PartnerRegistryGrid,
    },
})
export default class PartnerRegistry extends Vue {

    // -----------------------------------------------------------------
    // Properties

    public partnersList: any = {
        'content-partner' : {
            name: 'Content Partners',
            groupsType: ['content_developers'],
            key: 'content-partner',
        },
        'learner-product': {
            name: 'eLearning Providers',
            groupsType: ['lab_schools', 'schools'],
            key: 'learner-product',
        },
        'tech-partner': {
            name: 'EdTech Companies',
            groupsType: ['integration_partners'],
            key: 'tech-partner',
        },
        'researcher': {
            name: 'Researchers',
            groupsType: ['researchers'],
            key: 'researcher',
        },
        // 'program-partner': {
        //     name: 'Funders',
        //     groupsType: ['funders'],
        //     key: 'program-partner',
        // },
    };

    // public activeTab = this.partnersList[0];

    public tableContentHead = [
        {
            label: 'Name',
            key: 'partner_name',
            thClass: 'partner-detail-column',
        },
        {
            label: 'About',
            key: 'about',
            thClass: 'about-content-column',
        },
        // {
        //     label: 'Subject',
        //     key: 'subject',
        // },
        // {
        //     label: 'Grade Range',
        //     key: 'grade-range',
        // },
        // {
        //     label: '# of Products',
        //     key: 'metrics.data_count',
        // },
    ];

    public filterList: any = [];

    public tableContent: any = [];

    @Prop()
    public activePartner?: any;

    public permissonCheck: any = PERMISSION_CHECK;

    public partnerList: any = [];

    public isLoading: boolean = false;

    public searchTerms: string = '';

    public filterFields: any = ['partner_name'];

    private partnerNames = {
        content_developers : 'Content Partners',
        lab_schools: 'eLearning Providers',
        schools: 'eLearning Providers',
        integration_partners: 'EdTech Companies',
        researchers: 'Researchers',
        funders: 'Funders',
    };

    private activeMenu: any = 'content-partner';

    // -----------------------------------------------------------------
    // Actions

    public onAddPartner() {
        const groupType = this.partnersList[this.activeMenu].groupsType; // this.activeTab.groupsType || [];
        this.$emit('onAddPartner', groupType[0]);
    }

    // -----------------------------------------------------------------
    // Methods


    public fetchPartnersList() {
        const that = this;
        that.isLoading = true;
        const partners = that.$store.state.partnerDataStore.modifiedPartnerList;
        // this.$store.dispatch('partnerDataStore/fetchModifiedPartnerList').then((partners: any) => {
        if (partners && !isEmptyObjectCheck(partners)) {
            that.partnerList = partners;
            that.loadPartnerContent(partners);
            that.isLoading = false;
        } else {
            setTimeout(() => {
                that.fetchPartnersList();
            }, 1000);
        }
    }

    @Watch('$route')
    private onChangeRoute() {
        this.searchTerms = '';
        this.activeMenu = this.$route.query.activeMenu;
        this.loadPartnerContent(this.partnerList);
    }

    private showDeatils(details: any) {
        this.$emit('onShowPartnerDetails', details);
    }

    // -----------------------------------------------------------------
    // Hooks

    private created() {
        if (this.$route.query && this.$route.query.activeMenu) {
            this.activeMenu = this.$route.query.activeMenu;
        } else {
            this.activeMenu = 'content-partner';
        }
        this.fetchFreshPartnerList();
    }

    private loadPartnerContent(partners: any) {
        this.tableContent = [];
        this.filterList = [];
        const activeGroups =  this.partnersList[this.activeMenu].groupsType; // this.activeTab.groupsType || [];
        if (activeGroups) {
            activeGroups.forEach((groupType: any) => {
                this.tableContent = [...this.tableContent, ...partners[groupType]];
                this.filterList = [...this.filterList, ...partners[groupType]];
                // this.onSearchPartner();
            });
        }
    }

    private onSearchItemsText(value: any) {
        let textsearch = '';
        if (value && value.length >= 3) {
            textsearch = value;
        } else {
            textsearch = '';
        }
        this.filterList = [...this.tableContent].filter(
            (item: any) => item.partner_name.toLowerCase().startsWith(textsearch.toLowerCase()),
            );
    }

    private fetchFreshPartnerList() {
        const that = this;
        that.isLoading = true;
        that.$store.state.partnerDataStore.modifiedPartnerList = {};
        this.$store.dispatch('partnerDataStore/fetchModifiedPartnerList').then((data: any) => {
            that.isLoading = false;
            that.fetchPartnersList();
        });
    }
}
